import { PolicyPurchaseRatingDto } from '../services/policyPurchaseRating/dto/policyPurchaseRatingDto';
import policyPurchaseRatingService from '../services/policyPurchaseRating/policyPurchaseRatingService';
import { CrudStoreBase } from './crudStoreBase';

class PolicyPurchaseRatingStore extends CrudStoreBase<PolicyPurchaseRatingDto>{
  constructor() {
    super(policyPurchaseRatingService, defaultPolicyPurchaseRating)
  }

  public async create(createUserInput: PolicyPurchaseRatingDto) {
    return policyPurchaseRatingService.create(createUserInput);
  }

  public resetDataSet() {
    this.dataSet = {
        totalCount: 0,
        items: [],
    };
  }
}

export const defaultPolicyPurchaseRating = {
  id: '',
  userId: 0,
  policyId: 0,
  rating: 0,
  comment: '',
  actionType: '',
  redirectedToStore: false,
  platform: '',
  osVersion: '',
  appVersion: '',
  deviceModel: '',
  promptShownAt: '',
  ratedAt: '',
  lastModificationTime: '',
  lastModifierUserId: 0,
  creationTime: '',
  creatorUserId: 0,
}

export default PolicyPurchaseRatingStore;